import AdminResultEntry from './AdminResultEntry';
import AdminResultAssessmentTabs from './AdminResultAssessmentTabs';

const AdminEnterSecondTest = () => (
  <AdminResultAssessmentTabs>
    <AdminResultEntry assessmentType="second_test" />
  </AdminResultAssessmentTabs>
);

export default AdminEnterSecondTest;
